/**
 * DAKeyMetricsService - Refactorisé pour utiliser le client API centralisé
 */
import apiClient from '../../../services/api';

export default class DAKeyMetricsService {
    getKeyMetricsForCompany = (body) => {
        return apiClient.post("/dataAnalysis/keymetrics", body);
    }
}
